import gsap from 'gsap';

if($('.module--animated-header__images').length) {
  const start = gsap.timeline({
    paused: true,
    repeat: -1,
  });

  start
      .to('.module--animated-header__images__image', {
          stagger: 1.6,
          opacity: 1,
          duration: 2,
          transform: 'scale(2) translate3d(0, 0, 0)',
          ease: 'linear',
          filter: 'blur(0px)',
      })
      .to('.module--animated-header__images__image', {
          stagger: 1.6,
          opacity: 0,
          duration: 1.6,
          transform: 'scale(2.7) translate3d(0, 0, 0)',
          ease: 'linear',
      }, 1.8)

  const timelineToggle = (timeline) => {
    if( timeline.progress() < 1 ) {
      timeline.play();
    } else {
      timeline.restart();
    }
  }

  timelineToggle(start);

  // wait until gsap animation above is done
  // setTimeout(function() {
    const move = $('.module--animated-header__images');

    // Move images on mouse move
    $(document).mousemove(function(e) {
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const moveX = (mouseX - centerX) * 0.05;
      const moveY = (mouseY - centerY) * 0.05;

      move.css('transform', `translate(${moveX}px, ${moveY}px)`);
    });
  // }, 7500);
}
